/* PlansPricingContainer.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { AppListing2LineSkeleton, NotFound, PartialOutageError, useAppPlans, useTeamSizeAndBillingFrequency } from '@atlassian/mpac-primitives';
import { MarketplaceBillingCycle as BillingCycle } from '@atlassian/mpac-types/graphql-gateway-types';
import { ApolloErrorHandler } from '@atlassian/mpac-ui';
import { PAID_APP_CTA_LABEL_START_TRIAL, TEST_ID } from '../../../../../../constants';
import { PlansPricing } from './PlansPricing';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _4 = "._4t3i1osq{height:100%}";
const _3 = "._1bsb1osq{width:100%}";
const _2 = "._kqswstnw{position:absolute}";
const _ = "._1yt4xy5q{padding:var(--ds-space-400,2pc)}";
const errorContainer = null;
export const PlansPricingContainer = _ref => {
  var _error$extraInfo;
  let {
    appId,
    onPricingCalculatorInstallCTAClick
  } = _ref;
  const {
    data,
    loading,
    error
  } = useAppPlans({
    appId
  });
  const {
    teamSize,
    onTeamSizeChange,
    billingFrequency,
    onBillingFrequencyChange,
    lastTierCeiling
  } = useTeamSizeAndBillingFrequency({
    data
  });
  if (loading) {
    return /*#__PURE__*/_jsx(AppListing2LineSkeleton, {
      testId: TEST_ID.PRICING_TAB_EDITIONS_LOADING
    });
  }
  const handleStartFreeTrialClick = selectedPlan => {
    onPricingCalculatorInstallCTAClick({
      billingCycle: billingFrequency === 'annualPricingPlan' ? BillingCycle.Annual : BillingCycle.Monthly,
      userCount: teamSize,
      label: PAID_APP_CTA_LABEL_START_TRIAL,
      selectedPlan
    });
  };
  if (data) {
    return /*#__PURE__*/_jsx(PlansPricing, {
      editions: data.editions,
      teamSize: teamSize,
      onTeamSizeChange: onTeamSizeChange,
      billingFrequency: billingFrequency,
      onBillingFrequencyChange: onBillingFrequencyChange,
      lastTierCeiling: lastTierCeiling,
      handleStartFreeTrialClick: handleStartFreeTrialClick
    });
  }
  if (error && ((_error$extraInfo = error.extraInfo) === null || _error$extraInfo === void 0 ? void 0 : _error$extraInfo.code) !== 'NOT_FOUND') {
    return /*#__PURE__*/_jsx(ApolloErrorHandler, {
      error: error,
      context: {
        page: 'MPACPricingPlansPage',
        operationName: 'GetAppDetailsWithEditions'
      },
      renderError: () => /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_, _2, _3, _4]
        }), /*#__PURE__*/_jsx("div", {
          className: ax(["_1yt4xy5q _kqswstnw _1bsb1osq _4t3i1osq"]),
          children: /*#__PURE__*/_jsx(PartialOutageError, {
            level: "global"
          })
        })]
      })
    });
  }
  return /*#__PURE__*/_jsx(NotFound, {});
};